import { ElMessage } from 'element-plus'
import {File, get} from "@/assets/Api";

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xdc00 && code <= 0xdfff) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

var lastUuid = 0

export function uuid() {
    return new Date().getTime() * 1000 + (lastUuid++ % 1000)
}
export function timeData(date) {
    let dataaStr = new Date(date)
    let month = dataaStr.getMonth() + 1
    let day = dataaStr.getDate()
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    return dataaStr.getFullYear() + '-' + month + '-' + day
}

//生成随机字符串
//len 长度 type： num str all
export function makeRandom(len = 6, type) {
    var text = ''
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    var possible
    if (type == 'num') {
        possible = '0123456789'
    } else if (type == 'str' || !type) {
        possible = str
    } else if (type == 'all') {
        possible = str + '0123456789'
    }
    for (var i = 0; i < len; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
}

export function identification() {
    return new Date().valueOf() + makeRandom(6)
}

/*********自定义函数**********/

//获取字典Value
export function getdictName(dictCode, codeList) {
    let str = ''
    if (Array.isArray(dictCode)) {
        dictCode.map((item, index) => {
            ;(codeList || []).map(iteminner => {
                if (iteminner.dictCode == item) {
                    if (index != dictCode.length - 1) {
                        str += iteminner.dictName + '、'
                    } else {
                        str += iteminner.dictName
                    }
                }
            })
        })
        return str
    }
    let select = (codeList ? codeList : []).filter(item => {
        return item.dictCode == dictCode
    })
    return select && select[0] && select[0].dictName ? select[0].dictName : ''
}

export function getTreeName(
    dictCode,
    codeList,
    children = 'children',
    value = 'dictCode',
    label = 'dictName'
) {
    if (!dictCode && dictCode !== 0) {
        return ''
    }
    let strArr = []
    ;(Array.isArray(dictCode) ? dictCode : [dictCode]).map(item => {
        ;(codeList || []).map(iteminner => {
            if (iteminner[value] == item) {
                strArr = [...strArr, iteminner[label]]
            }
            if (children && iteminner[children]) {
                strArr = [
                    ...strArr,
                    ...getTreeName(item, iteminner[children], children, value, label),
                ]
            }
        })
    })
    return strArr
}

export function hasThisButton(code) {
    return true
    let limit = getLimit()
    if (limit) {
        let selectAttr = limit.filter(item => {
            return item.menuCode == code
        })
        if (selectAttr && selectAttr.length != 0) {
            return true
        } else {
            return false
        }
    }
}

export function ishasValue(row, key) {
    let value = row[key] || row[key] === 0 ? row[key] : '--'
    return value
}

export function throttle(fn, interval = 500) {
    //节流

    let timer = null
    let firstTime = true

    return () => {
        let args = arguments
        if (firstTime) {
            // 第一次加载
            fn.apply(this, args)
            return (firstTime = false)
        }
        if (timer) {
            // 定时器正在执行中，跳过
            return
        }

        timer = setTimeout(() => {
            clearTimeout(timer)
            timer = null
            fn.apply(this, args)
        }, interval)
    }
}

var getWindow = function (node) {
    var doc = node.ownerDocument || node
    return doc.defaultView || doc.parentWindow
}

// 获取el位置
export function getClientRect(element) {
    var bcr
    //trace  IE6下在控制编辑器显隐时可能会报错，catch一下
    try {
        bcr = element.getBoundingClientRect()
    } catch (e) {
        bcr = { left: 0, top: 0, height: 0, width: 0 }
    }
    var rect = {
        left: Math.round(bcr.left),
        top: Math.round(bcr.top),
        height: Math.round(bcr.bottom - bcr.top),
        width: Math.round(bcr.right - bcr.left),
    }
    var doc
    while (
        (doc = element.ownerDocument) !== document &&
        (element = getWindow(doc).frameElement)
        ) {
        bcr = element.getBoundingClientRect()
        rect.left += bcr.left
        rect.top += bcr.top
    }
    rect.bottom = rect.top + rect.height
    rect.right = rect.left + rect.width
    return rect
}

// 下载文件
export function downloadFile(content, filename, type) {
    return new Promise((resolve, reject) => {
        try {
            // 创建隐藏的可下载链接
            let url, blob
            // 字符内容转变成blob地址
            switch (type) {
                case 'excel':
                    blob = new Blob([content], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'doc':
                    blob = new Blob([content], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'other':
                    blob = new Blob([content], {
                        type: 'application/octet-stream;charset=utf-8',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'file':
                    blob = new Blob([content], {
                        type: 'text/plain;charset=utf-8',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'zip':
                    blob = new Blob([content], {
                        type: 'application/zip',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'xml':
                    blob = new Blob([content], {
                        type: 'application/xml;charset=utf-8',
                    })
                    url = URL.createObjectURL(blob)
                    break
                case 'url':
                    url = content
                    break
                default:
                    blob = content
                    url = URL.createObjectURL(blob)
                    break
            }
            let eleLink
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                // console.log(blob)
                // eleLink = document.createElement("iframe");
                // eleLink.src = url;
                blob
                    ? window.navigator.msSaveBlob(blob, filename)
                    : window.open(url, '_blank')
            } else {
                eleLink = document.createElement('a')
                eleLink.href = url
                eleLink.style.display = 'none'
                filename ? (eleLink.download = filename) : null
                document.body.appendChild(eleLink)
                // 触发点击
                eleLink.click()
                // 然后移除
                document.body.removeChild(eleLink)
            }
            resolve(blob)
        } catch (error) {
            reject(error)
        }
    })
}

export function judgeLink(to, next) {
    // 路由验证权限
    if (to.meta.authority) {
        // to.meta.code
        let authority = to.meta.authority ? to.meta.authority.split(',') : [],
            judge = true
        for (let i in authority) {
            if (authority[i] === 'unable') {
                judge = true
                break
            }
            if (hasThisButton(authority[i])) {
                judge = false
            }
        }
        if (judge) {
            ElMessage({
                showClose: true,
                message: '您暂无权限访问该页面',
                type: 'error',
            })
            next('/')
            return false
        }
    }
    return true
}

// 获取当前时间/时间戳
export function getTimeNum(j) {
    return j ? new Date() : new Date().valueOf()
}
// 时间戳转换为时间
export function timestampToTime(timestamp) {
    timestamp
        ? (timestamp =
            typeof timestamp == 'string'
                ? timeToTimestamp(timestamp)
                : timestamp.valueOf())
        : (timestamp = getTimeNum())
    let date = new Date(timestamp)
    let Y = date.getFullYear()
    let M =
        date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    let w = date.getDay()
    return {
        Year: Y,
        Month: M,
        Day: D,
        Hour: h,
        Minite: m,
        Second: s,
        Week: w,
    }
}
// 上下午时间
export function transTime(time, en) {
    if (time) {
        let timeArr = time.split(':')
        timeArr[0] =
            Number(timeArr[0]) > 12
                ? en
                    ? Number(timeArr[0] - 12) + (en === 'small' ? 'pm' : 'PM')
                    : '下午 ' + Number(timeArr[0] - 12)
                : en
                    ? timeArr[0] + (en === 'small' ? 'am' : 'AM')
                    : '上午 ' + timeArr[0]
        return timeArr.join(':')
    }
    return time
}
// 时间格式化
export function TimeTransform(type, addtime, updatetime, hasSecond, showAll) {
    if (!addtime && !updatetime) {
        addtime = getTimeNum()
    }
    let time
    if (updatetime && updatetime != null && updatetime != '') {
        time = updatetime
    } else {
        time = addtime
    }
    if (type) {
        let time_trans, NewTime
        let j = false
        // console.log(NewTime)
        type === '差值' || type === '差值1'
            ? null
            : (NewTime = timestampToTime(time))
        switch (type) {
            case '区间':
                let UntilTime = Math.round(
                    parseInt(Number(getTimeNum()) / 1000 - Number(time)) / 3600
                )
                if (UntilTime == 0) {
                    let UntilT = parseInt(
                        (60 * (Number(getTimeNum()) / 1000 - Number(time))) / 3600
                    )
                    UntilT = UntilT == 0 ? 1 : UntilT
                    time_trans = UntilT + '分钟前'
                } else if (UntilTime < 24) {
                    time_trans = UntilTime + '小时前'
                } else if (UntilTime < 48) {
                    time_trans = '1天前'
                } else if (UntilTime < 72) {
                    time_trans = '2天前'
                } else {
                    time_trans =
                        NewTime.Year +
                        '年' +
                        NewTime.Month +
                        '月' +
                        NewTime.Day +
                        '日 ' +
                        NewTime.Hour +
                        ':' +
                        NewTime.Minite
                }
                break
            case '差值':
                if (!addtime) {
                    return ''
                }
                addtime =
                    typeof addtime == 'string'
                        ? timeToTimestamp(addtime)
                        : addtime.valueOf()
                updatetime || updatetime === 0
                    ? (updatetime =
                        typeof updatetime == 'string'
                            ? timeToTimestamp(updatetime)
                            : updatetime.valueOf())
                    : null
                time =
                    (updatetime || updatetime === 0 ? updatetime - addtime : addtime) /
                    1000
                time < 0 ? ((time = -time), (j = true)) : null
                var d = 24 * 60 * 60,
                    h = 60 * 60,
                    m = 60
                var day = Math.floor(time / d),
                    hour = Math.floor((time % d) / h),
                    minite = Math.floor(((time % d) % h) / m),
                    second = Math.floor(((time % d) % h) % m)
                // console.log(day,hour,minite,second)
                time_trans = { day, hour, minite, second }
                // time_trans=day?
                // (day+'天'+(hour?(hour+'小时'):'1小时')):
                // ((hour?(hour<10?('0'+hour):hour):'00')+':'+(minite?(minite<10?('0'+minite):minite):'00')+':'+(second?(second<10?('0'+second):second):'01'));
                time_trans =
                    (day ? day + '天' : showAll ? '0天' : '') +
                    (hour ? hour + '小时' : showAll ? '0小时' : '') +
                    (minite ? minite + '分钟' : showAll ? '0分钟' : '') +
                    (hasSecond ? (second ? second + '秒' : showAll ? '0秒' : '') : '')
                j ? (time_trans = '-' + time_trans) : null
                break
            case '差值1':
                if (!addtime) {
                    return ''
                }
                addtime =
                    typeof addtime == 'string'
                        ? timeToTimestamp(addtime)
                        : addtime.valueOf()
                updatetime || updatetime === 0
                    ? (updatetime =
                        typeof updatetime == 'string'
                            ? timeToTimestamp(updatetime)
                            : updatetime.valueOf())
                    : null
                time = addtime / 1000
                time < 0 ? ((time = -time), (j = true)) : null
                var d = 24 * 60 * 60,
                    h = 60 * 60,
                    m = 60
                var day = Math.floor(time / d),
                    hour = Math.floor((time % d) / h),
                    minite = Math.floor(((time % d) % h) / m),
                    second = Math.floor(((time % d) % h) % m)
                // console.log(day,hour,minite,second)
                time_trans = { day, hour, minite, second }
                time_trans = day
                    ? day + '天' + (hour ? hour + '小时' : '1小时')
                    : (hour ? (hour < 10 ? '0' + hour : hour) : '00') +
                    ':' +
                    (minite ? (minite < 10 ? '0' + minite : minite) : '00') +
                    ':' +
                    (second ? (second < 10 ? '0' + second : second) : '01')
                j ? (time_trans = '-' + time_trans) : null
                break
            default:
                type = type.replace('YYYY', NewTime.Year)
                type = type.replace('yyyy', NewTime.Year)
                type = type.replace('YY', NewTime.Year.toString().slice(2, 4))
                type = type.replace('yy', NewTime.Year.toString().slice(2, 4))
                type = type.replace('MM', NewTime.Month)
                type = type.replace('M', Number(NewTime.Month))
                type = type.replace('DD', NewTime.Day)
                type = type.replace('dd', NewTime.Day)
                type = type.replace('D', Number(NewTime.Day))
                type = type.replace('d', Number(NewTime.Day))
                type = type.replace('hh', NewTime.Hour)
                type = type.replace('HH', NewTime.Hour)
                type = type.replace('mm', NewTime.Minite)
                type = type.replace('ss', NewTime.Second)
                type = type.replace('SS', NewTime.Second)
                let week = ['日', '一', '二', '三', '四', '五', '六']
                let weekTxt =
                    NewTime.Week || NewTime.Week === 0 ? week[Number(NewTime.Week)] : ''
                type = type.replace('W', weekTxt)
                return type
        }
        return time_trans
    }
    return addtime
}
// 时间转换为时间戳
export function timeToTimestamp(value) {
    var time = null
    if (value !== '' && value !== null) {
        value = value.toString()
        value = value.split('/').join(',')
        value = value.split(' ').join(',')
        value = value.split('-').join(',')
        value = value.split(':').join(',')
        var arr = value.split(',')
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == null) {
                arr.splice(i, 1)
                i--
            }
        }
        time = new Date(
            arr[0],
            arr[1] - 1,
            arr[2],
            arr[3] ? arr[3] : 0,
            arr[4] ? arr[4] : 0,
            arr[5] ? arr[5] : 0
        )
        time = time.valueOf()
    }
    return time
}
// CST转换GMT
export function getTaskTime(strDate) {
    if (null == strDate || '' == strDate) {
        return ''
    }
    var dateStr = strDate.trim().split(' ')
    var strGMT =
        dateStr[0] +
        ' ' +
        dateStr[1] +
        ' ' +
        dateStr[2] +
        ' ' +
        dateStr[5] +
        ' ' +
        dateStr[3] +
        ' GMT+0800'
    var date = new Date(Date.parse(strGMT))
    return date
}
// 本年第几周
export function getWeekOfYear(today) {
    var today = today ? new Date(timeToTimestamp(today)) : new Date()
    var firstDay = new Date(today.getFullYear(), 0, 1)
    var dayOfWeek = firstDay.getDay()
    var spendDay = 1
    if (dayOfWeek != 0) {
        spendDay = 7 - dayOfWeek + 1
    }
    firstDay = new Date(today.getFullYear(), 0, 1 + spendDay)
    var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000)
    var result = Math.ceil(d / 7)
    return result + 1
}
// 获取本月天数
export function getDays(n) {
    var today = new Date()
    var d = new Date(
        today.getFullYear(),
        Number(today.getMonth() + 1 + (n ? n : 0)),
        0
    )
    return d.getDate()
}
// 递归获取数据
export function recursion(
    item_,
    id = 'id',
    children = 'children',
    disabled = 'disabled'
) {
    let item = JSON.parse(JSON.stringify(item_))
    let arr = []
    item && item[disabled] ? null : arr.push(item[id])
    if (item[children] && item[children].length > 0) {
        for (let i in item[children]) {
            arr = arr.concat(recursion(item[children][i], id, children))
        }
    }
    return arr
}
// 递归成树
export function toTree(arr, opt = {}) {
    let code = opt.code || null,
        id = opt.id || 'id',
        children = opt.children || 'children',
        pid = opt.pid || 'pid'
    if (arr.length == 0) {
        return []
    }
    let allTree = arr.filter(v =>
        !code
            ? v[pid] === undefined ||
            v[pid] === '' ||
            v[pid] === null ||
            v[pid] === 0 ||
            v[pid] === '0'
            : v[pid] == code
    )
    return allTree.map(v => {
        v.children = toTree(
            arr.filter(
                v =>
                    !(!code
                        ? v[pid] === undefined ||
                        v[pid] === '' ||
                        v[pid] === null ||
                        v[pid] === 0 ||
                        v[pid] === '0'
                        : v[pid] == code)
            ),
            {
                code: v[id],
                id,
                children,
                pid,
            }
        )
        v[children].length == 0 ? delete v[children] : null
        return {
            ...v,
        }
    })
}
export function JudgeClass(el, name) {
    var e = el || window.event || arguments[0]
    var elme = e.target || e.srcElement
    var className = []
    var getclass = function () {
        if (elme.classList && elme.classList.length > 0) {
            className.push(elme.classList)
        }
        if (elme.parentElement || elme.parentNode) {
            elme = elme.parentElement || elme.parentNode
            getclass()
        }
    }
    getclass()
    if (name) {
        let names = name.split(',')
        for (var i = 0; i < className.length; i++) {
            for (var j = 0; j < className[i].length; j++) {
                if (names.indexOf(className[i][j]) > -1) {
                    return true
                }
            }
        }
    }
    return false
}

export function getMatched(this_) {
    // console.log(this_.$route)
    if (!this_.$route.meta || !this_.$route.meta.title) {
        return []
    }
    // console.log(this_.$route.matched)
    let matched = (this_.$route.matched || []).filter(
        item =>
            this_.$route.meta &&
            this_.$route.meta.title &&
            (item.name === this_.$route.name ||
                (this_.$route.meta.pname && item.name === this_.$route.meta.pname))
    )
    // console.log(matched)
    if (matched.length == 0) {
        return []
    }
    const first = matched[0]
    if (first.name === this_.$route.name) {
        matched = [first]
    }
    return matched.map(v => v.meta.title)
}

export function replaceBr(val, type) {
    // type 不传无变化,  1 替换val中回车为html的<br/> 空格为html的&bsp,  2 替换为段落,  3 回车替换为空格,  4 清除回车空格返回纯文本

    if (val) {
        val = val.toString()
        switch (type) {
            case 1:
                return val
                    .replace(/\r\n/g, '<br/>')
                    .replace(/\n/g, '<br/>')
                    .replace(/\r/g, '<br/>')
                    .replace(/\s/g, '&nbsp;')
            case 2:
                return (
                    '<p>' +
                    val
                        .replace(/\r\n/g, '</p><p>')
                        .replace(/\n/g, '</p><p>')
                        .replace(/\r/g, '</p><p>')
                        .replace(/\s/g, '&nbsp;') +
                    '</p>'
                )
            case 3:
                return val.replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\r/g, ' ')
            case 4:
                return val
                    .replace(/\r\n/g, '')
                    .replace(/\n/g, '')
                    .replace(/\r/g, '')
                    .replace(/\s/g, '')
        }
    } else {
        return ''
    }
}

export function replaceSpace(val, type) {
    // type 不传返回val去头尾空格,  1 返回去除所有空格, 2 返回去头尾空格 文字间多个空格只保留一个
    if (val) {
        val = val.toString()
        if (type) {
            switch (type) {
                case 1:
                    return val.replace(/\s/g, '')
                case 2:
                    var text = val
                        .replace(/^\s\s*/, '')
                        .replace(/\s\s*$/, '')
                        .replace(/\s\s*/g, ' ')
                    return text
                case 'html':
                    var text = val.replace(/\s\s*/g, '&nbsp;')
                    return text
            }
        }
        return val.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
    } else {
        return ''
    }
}

export function getItemVal(arr, key, id, opt = {}) {
    let idname = opt.idname || 'id',
        children = opt.children || 'children'
    for (let i in arr) {
        if (arr[i][idname] == id) {
            // console.log(arr[i][key], key, arr[i], id);
            return arr[i][key]
        }
        if (arr[i][children] && arr[i][children].length > 0) {
            let res = getItemVal(arr[i][children], key, id, opt)
            if (res !== null) {
                return res
            }
        }
    }
    return null
}

export const beautifierConf = {
    html: {
        indent_size: '2',
        indent_char: ' ',
        max_preserve_newlines: '-1',
        preserve_newlines: false,
        keep_array_indentation: false,
        break_chained_methods: false,
        indent_scripts: 'separate',
        brace_style: 'end-expand',
        space_before_conditional: true,
        unescape_strings: false,
        jslint_happy: false,
        end_with_newline: true,
        wrap_line_length: '110',
        indent_inner_html: true,
        comma_first: false,
        e4x: true,
        indent_empty_lines: true,
    },
    js: {
        indent_size: '2',
        indent_char: ' ',
        max_preserve_newlines: '-1',
        preserve_newlines: false,
        keep_array_indentation: false,
        break_chained_methods: false,
        indent_scripts: 'normal',
        brace_style: 'end-expand',
        space_before_conditional: true,
        unescape_strings: false,
        jslint_happy: true,
        end_with_newline: true,
        wrap_line_length: '110',
        indent_inner_html: true,
        comma_first: false,
        e4x: true,
        indent_empty_lines: true,
    },
}

export function getExploreName() {
    var userAgent = navigator.userAgent
    if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        return 'Opera'
    } else if (
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1
    ) {
        return 'IE'
    } else if (userAgent.indexOf('Edge') > -1) {
        return 'Edge'
    } else if (userAgent.indexOf('Firefox') > -1) {
        return 'Firefox'
    } else if (
        userAgent.indexOf('Safari') > -1 &&
        userAgent.indexOf('Chrome') == -1
    ) {
        return 'Safari'
    } else if (
        userAgent.indexOf('Chrome') > -1 &&
        userAgent.indexOf('Safari') > -1
    ) {
        return 'Chrome'
    } else if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return 'IE>=11'
    } else {
        return 'Unkonwn'
    }
}

export function contentType(name) {
    let FilenameExtension = name.toUpperCase().split('.')[
    name.toUpperCase().split('.').length - 1
        ]
    if (FilenameExtension === 'BMP') {
        return 'image/bmp'
    }
    if (FilenameExtension === 'GIF') {
        return 'image/gif'
    }
    if (
        FilenameExtension === 'JPEG' ||
        FilenameExtension === 'JPG' ||
        FilenameExtension === 'PNG'
    ) {
        return 'image/jpeg'
    }
    if (FilenameExtension === 'HTML') {
        return 'text/html'
    }
    if (FilenameExtension === 'TXT') {
        return 'text/plain'
    }
    if (FilenameExtension === 'VSD') {
        return 'application/vnd.visio'
    }
    if (FilenameExtension === 'PPTX' || FilenameExtension === 'PPT') {
        return 'application/vnd.ms-powerpoint'
    }
    if (FilenameExtension === 'XLSX' || FilenameExtension === 'XLS') {
        return 'application/vnd.ms-excel'
    }
    if (FilenameExtension === 'DOCX' || FilenameExtension === 'DOC') {
        return 'application/msword'
    }
    if (FilenameExtension === 'XML') {
        return 'text/xml'
    }
    if (FilenameExtension === 'PDF') {
        return 'application/pdf'
    }
    return null
}

export function imgTypeValid(dataPrix) {
    if (dataPrix.indexOf('data:image/jpeg;') > -1) {
        return '.jpeg'
    } else if (dataPrix.indexOf('data:image/jpg;') > -1) {
        return '.jpg'
    } else if (dataPrix.indexOf('data:image/gif;') > -1) {
        return '.gif'
    } else if (dataPrix.indexOf('data:image/png;') > -1) {
        return '.png'
    } else if (dataPrix.indexOf('data:image/apng;') > -1) {
        return '.apng'
    } else if (dataPrix.indexOf('data:image/svg;') > -1) {
        return '.svg'
    } else if (dataPrix.indexOf('data:image/bmp;') > -1) {
        return '.bmp'
    }
    return null
}

export function fileTypeValid(dataPrix) {
    if (dataPrix.indexOf('data:text/plain;') > -1) {
        return '.txt'
    }
    return null
}

export function getFunctionName(fun) {
    var ret = fun.toString()
    ret = ret.substr('function '.length)
    ret = ret.substr(0, ret.indexOf('('))
    return ret.replace(/\s/g, '')
}
export function getFieldUpFirst(text) {
    return text ? text.substring(0, 1).toUpperCase() + text.substring(1) : ''
}
export function getFieldLoFirst(text) {
    return text ? text.substring(0, 1).toLowerCase() + text.substring(1) : ''
}
export function getField(text) {
    let arr = text ? text.split('_') : []
    if (arr.length > 1) {
        return getFieldLoFirst(arr.map(v => getFieldUpFirst(v)).join(''))
    } else {
        return text || ''
    }
}

export function getSize(size) {
    size = size && Number(size) ? Number(size) : 0
    // console.log(size/(1024*1024*1024*1024),size/(1024*1024*1024),size/(1024*1024),size/(1024))
    return size / (1024 * 1024 * 1024 * 1024) > 1
        ? Math.round((size * 100) / (1024 * 1024 * 1024 * 1024)) / 100 + 'TB'
        : size / (1024 * 1024 * 1024) > 1
            ? Math.round((size * 100) / (1024 * 1024 * 1024)) / 100 + 'GB'
            : size / (1024 * 1024) > 1
                ? Math.round((size * 100) / (1024 * 1024)) / 100 + 'MB'
                : size / 1024 > 1
                    ? Math.round((size * 100) / 1024) / 100 + 'KB'
                    : size + 'B'
}

export function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
    })

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
        ? 'rgb(' +
        [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
        ].join(',') +
        ')'
        : hex
}

export function hexToRgba(hex, opacity) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
    })

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    opacity = opacity >= 0 && opacity <= 1 ? Number(opacity) : 1
    return result
        ? 'rgba(' +
        [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
            opacity,
        ].join(',') +
        ')'
        : hex
}

export function rgbToHex(rgb) {
    var bg = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
    function hex(x) {
        return ('0' + parseInt(x).toString(16)).slice(-2)
    }
    return ('#' + hex(bg[1]) + hex(bg[2]) + hex(bg[3])).toUpperCase()
}

export function rgbaToHex(rgba) {
    var bg = rgba.match(
        /^rgb\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(\d|(\.[1-9]{1,2})))\)$/
    )
    function hex(x) {
        return ('0' + parseInt(x).toString(16)).slice(-2)
    }
    return ('#' + hex(bg[1]) + hex(bg[2]) + hex(bg[3])).toUpperCase()
}

export function judgeTo(path, type) {
    let json = {
        login: ['login', 'regist', 'forget', 'userVerification'],
    }
    if (!json[type] || !Array.isArray(json[type])) {
        return false
    }
    return json[type].indexOf(path) == -1
}

export function numberChange(ref, model, prop) {
    // console.log(ref, model, prop)
    let el = ref.nodeName == 'INPUT' ? ref : ref.getElementsByTagName('input')[0],
        inputing = true,
        maxlength = 12,
        point = -1,
        ableMinus = false
    const inputChange = () => {
        // console.log(maxlength, point)
        if (inputing) {
            return
        }
        let value = el.value.toString()
        let minus = ableMinus && value.indexOf('-') == 0
        let position = el.selectionStart
        if (value) {
            // console.log(value);
            value = value.toString()
            let reg = /[^0-9.]/g
            // 带非数字
            if (value != value.replace(reg, '')) {
                position =
                    el.selectionStart + (value.replace(reg, '').length - value.length)
                // console.log(position);
                el.value = value.replace(reg, '')
                value = el.value
            }
            let valueArr = value.split('.')
            // 无小数点超过maxlength位
            if (valueArr.length == 1 && value.length > maxlength) {
                position = el.selectionStart
                // console.log(position);
                value = value.slice(0, maxlength)
            }
            // 有小数点超过maxlength位
            else {
                let before = false,
                    after = false
                // 多个小数点
                if (valueArr.length > 2) {
                    value = valueArr[0] + '.' + valueArr[1]
                    position = value.length
                    valueArr = value.split('.')
                }
                // 小数点前超过maxlength位
                if (valueArr.length > 1 && valueArr[0].length > maxlength) {
                    before = true
                    position = el.selectionStart - 1
                    // console.log(position);
                    value =
                        value.slice(0, position) + value.slice(position + 1, value.length)
                }
                // 小数点后超过point位
                if (point >= 0 && valueArr.length > 1 && valueArr[1].length > point) {
                    after = true
                    position = el.selectionStart - 1
                    value =
                        value.slice(0, value.indexOf('.') + 1) + valueArr[1].slice(0, point)
                }
                before && after ? (position = el.selectionStart) : null
            }
        }
        if (minus) {
            position = el.selectionStart + 1
            value = '-' + value
        }
        model[prop] = value.toString()
        el.value = model[prop]
        el.setSelectionRange(position, position)
    }
    const numInput = el ? el.getAttribute('numInput') : null
    if (el && numInput) {
        inputing = false
        let numInputText = numInput.split(':').filter(v => v)
        // console.log(numInputText)
        maxlength =
            numInputText.length > 0
                ? Number(numInputText[0].split(',')[0])
                : maxlength
        point =
            numInputText.length > 0
                ? Number(numInputText[0].split(',')[1] || point)
                : maxlength
        ableMinus = numInputText.indexOf('ableMinus') > -1
        el.addEventListener('compositionstart', () => {
            inputing = true
        })
        el.addEventListener('compositionend', () => {
            inputing = false
            inputChange()
        })
        el.oninput = function () {
            inputChange()
        }
        el.onblur = function () {
            model[prop] =
                !model[prop] && model[prop] !== 0
                    ? model[prop]
                    : Number(model[prop]).toString()
        }
    }
}

export function getIdCardsInfo(UUserCard) {
    if (UUserCard != null && checkID(UUserCard)) {
        //获取出生日期
        let birth =
                UUserCard.substring(6, 10) +
                '-' +
                UUserCard.substring(10, 12) +
                '-' +
                UUserCard.substring(12, 14),
            gender,
            genderLabel,
            age;
        //获取性别
        if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
            gender = 1;
            genderLabel = '男';
        } else {
            gender = 0;
            genderLabel = '女';
        }
        //获取年龄
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
        if (
            UUserCard.substring(10, 12) < month ||
            (UUserCard.substring(10, 12) == month &&
                UUserCard.substring(12, 14) <= day)
        ) {
            age++;
        }
        return {
            birth,
            age,
            gender,
            genderLabel,
        };
    }
    return false;
}

export function getShortDistance(lon1, lat1, lon2, lat2) {
    var DEF_PI = Math.PI; // PI
    var DEF_2PI = Math.PI * 2; // 2*PI
    var DEF_PI180 = Math.PI / 180; // PI/180.0
    var DEF_R = 6370693.5; // radius of earth
    var ew1, ns1, ew2, ns2;
    var dx, dy, dew;
    var distance;
    // 角度转换为弧度
    ew1 = lon1 * DEF_PI180;
    ns1 = lat1 * DEF_PI180;
    ew2 = lon2 * DEF_PI180;
    ns2 = lat2 * DEF_PI180;
    // 经度差
    dew = ew1 - ew2;
    // 若跨东经和西经180 度，进行调整
    if (dew > DEF_PI) dew = DEF_2PI - dew;
    else if (dew < -DEF_PI) dew = DEF_2PI + dew;
    dx = DEF_R * Math.cos(ns1) * dew; // 东西方向长度(在纬度圈上的投影长度)
    dy = DEF_R * (ns1 - ns2); // 南北方向长度(在经度圈上的投影长度)
    // 勾股定理求斜边长
    distance = Math.sqrt(dx * dx + dy * dy).toFixed(0);
    // console.log(distance);
    return distance;
}
// Object转FormData
export const objectToFormData = function(obj, form, namespace, hasNull) {
    let fd = form || new FormData();
    let formKey;
    if (obj instanceof Array) {
        for (let item of obj) {
            if (typeof item === 'object' && !(item instanceof File)) {
                objectToFormData(item, fd, namespace, hasNull); // + "[]"
            } else {
                // 若是数组则在关键字后面加上[]
                fd.append(namespace, item); // + "[]"
            }
        }
    } else {
        for (let property in obj) {
            if (namespace) {
                // 若是对象，则这样
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }
            if (obj.hasOwnProperty(property) && obj[property]) {
                // if the property is an object, but not a File,
                // use recursivity.
                if (
                    typeof obj[property] === 'object' &&
                    !(obj[property] instanceof File)
                ) {
                    // 此处将formKey递归下去很重要，因为数据结构会出现嵌套的情况
                    objectToFormData(obj[property], fd, formKey, hasNull);
                } else {
                    // if it's a string or a File object
                    fd.append(formKey, obj[property]);
                }
            } else if (hasNull && hasNull.indexOf(formKey) > -1) {
                fd.append(formKey, obj[property]);
            }
        }
    }
    return fd;
};

// 获取字典值
export function getDictLabel(dictKey, list) {
    return dictKey
        ? (list.find(v => v.dictKey == dictKey) || {}).dictValue || dictKey
        : ''
}
// api请求获取字典
export function getDict(dictType) {
    return new Promise((resolve, reject) => {
        get(`system/dict/data/type/${dictType}`)
            .then(res => {
                if (!res) return reject("请求失败");
                let data_ = res.data;
                resolve(data_);
            },err => {
                reject(err);
            })
    })
}

// js 语法 tolowercase 字符串都转成小写
